var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',[_c('tr',{staticStyle:{"font-size":"medium"}},[_c('td',[_c('span',{staticClass:"badge",staticStyle:{"color":"black"}},[_vm._v("Total a tratar : "+_vm._s(_vm.cantSuspATratar)+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }